module.exports = __webpack_public_path__ + "fa-regular-400.701ae6abd4719e9c2ada.eot";


//////////////////
// WEBPACK FOOTER
// E:/SafeCloud-FrontEnd/WebConsorcioPimentel/src/assets/plugins/FontAweson/webfonts/fa-regular-400.eot
// module id = ../../../../../src/assets/plugins/FontAweson/webfonts/fa-regular-400.eot
// module chunks = styles